export default __webpack_public_path__ + "static/media/format-align-right.6f27e095.svg";